import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/webhooks/')({
  beforeLoad: () => {
    throw redirect({
      to: '/webhooks/outbound',
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Redirecting...</div>
}
